export function extractStorageObjectPath(bucket: string, value: string | null | undefined) {
  const normalizedValue = value?.trim();
  if (!normalizedValue) return null;

  if (!/^https?:\/\//i.test(normalizedValue)) {
    return normalizedValue.replace(/^\/+/, "");
  }

  try {
    const parsed = new URL(normalizedValue);
    const patterns = [
      `/storage/v1/object/public/${bucket}/`,
      `/storage/v1/object/sign/${bucket}/`,
      `/storage/v1/object/authenticated/${bucket}/`,
      `/storage/v1/object/${bucket}/`,
    ];

    for (const prefix of patterns) {
      const index = parsed.pathname.indexOf(prefix);
      if (index >= 0) {
        return decodeURIComponent(parsed.pathname.slice(index + prefix.length)).replace(/^\/+/, "");
      }
    }
  } catch {
    return null;
  }

  return null;
}
